import api from '@shared/services/api';

export const art123Service = {
    getEmployerChanges: async (params = {}) => {
        const response = await api.get('/emp/change-employer', { params });
        return response.data;
    },

    getContractsChanges: async (params = {}) => {
        const response = await api.get('/emp-contracts/change-employer', { params });
        return response.data;
    },

    getChangeEmployerReasons: async () => {
        const response = await api.get('/hr-nssi-reason/9');
        return response.data;
    },

    generateAdditionalAgreement: async (data) => {
        const response = await api.post('/emp/change-employer', data);
        return response.data;
    },
};
